import { render, staticRenderFns } from "./FirmAboutPage.vue?vue&type=template&id=581d2b07&scoped=true&"
import script from "./FirmAboutPage.vue?vue&type=script&lang=js&"
export * from "./FirmAboutPage.vue?vue&type=script&lang=js&"
import style0 from "./FirmAboutPage.vue?vue&type=style&index=0&id=581d2b07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d2b07",
  null
  
)

export default component.exports